module.exports = __webpack_public_path__ + "static/media/caffe-milano.514b50cf.png";